<dx-form labelMode="floating">
  <dxi-item
    *ngIf="valueTextBoxNecessary"
    itemType="group"
    [colCount]="3"
  >
    <dxi-item name="selectBox" [colSpan]="2">
      <dx-select-box
        stylingMode="filled"
        [dataSource]="selectsDataSource"
        [(value)]="selectedOptionField"
        [label]="label || summaryField?.label || inputName || ''"
        displayExpr="prettifiedDisplayValue"
        [searchEnabled]="false"
        style="caret-color: transparent"
      ></dx-select-box>
    </dxi-item>
    <dxi-item name="selectBox" [colSpan]="1">
      <dx-text-box
        [disabled]="valueTextBoxDisabled"
        stylingMode="filled"
        [label]="
              formatMessage('calculator.calculation.us.optionValue') + ' *'
            "
        [(value)]="selectedOptionValue"
      ></dx-text-box>
    </dxi-item>
  </dxi-item>
  <dxi-item *ngIf="!valueTextBoxNecessary" name="selectBox">
    <dx-select-box
      stylingMode="filled"
      [dataSource]="selectsDataSource"
      [(value)]="selectedOptionField"
      [label]="label || summaryField?.label || inputName || ''"
      displayExpr="prettifiedDisplayValue"
      [searchEnabled]="false"
      style="caret-color: transparent"
    ></dx-select-box>
  </dxi-item>
</dx-form>


